import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import * as userActions from '../../containers/Login/actions';
import DB_CONST from '../../config/db_const';

import s from './style.less';

class Layout extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      const user = await fetch('/authorized', { credentials: 'include' });
      this.props.setUser({
        ...user,
      });
    } catch (e) {
      // Do nothing
    }

    this.finishLoading();
  }

  getUrlMeta = () => {
    let headerURL = '';
    let settingsLinkSufix = '';
    switch (this.props.role) {
      case DB_CONST.USER_ROLES.PROVIDER:
        headerURL = '/provider';
        settingsLinkSufix = 'provider';
        break;
      case DB_CONST.USER_ROLES.CUSTOMER:
        headerURL = '/customer/plans';
        settingsLinkSufix = 'customer';
        break;
      default:
        headerURL = '/';
        break;
    }

    return { headerURL, settingsLinkSufix };
  };

  finishLoading() {
    this.setState({
      loading: false,
    });
  }

  renderHeader() {
    const { role } = this.props;

    let Component;
    switch (role) {
      case DB_CONST.USER_ROLES.GUEST:
        Component = this.renderHeaderGuest();
        break;
      case DB_CONST.USER_ROLES.PROVIDER:
        Component = this.renderHeaderLoggedIn();
        break;
      case DB_CONST.USER_ROLES.CUSTOMER:
        Component = this.renderHeaderLoggedIn();
        break;
      case DB_CONST.USER_ROLES.ADMIN:
        Component = this.renderHeaderAdmin();
        break;
      default:
        Component = null;
    }
    return Component;
  }

  renderContacts = () => (
    <div className={s.contacts}>
      <div>Customer helpline: {DB_CONST.customerHelpline}</div>
      <div>
        Email:{' '}
        <a href="mailto:customercare@serviceplans.co.uk">
          customercare@serviceplans.co.uk
        </a>
      </div>
    </div>
  );

  renderHeaderGuest = () => (
    <div className={s.header}>
      <Link to="/login">
        <div className={s.logo} />
      </Link>
      {this.renderContacts()}
      <Link to="/login">
        <div className={s.nav}>Log In</div>
      </Link>
    </div>
  );

  renderHeaderLoggedIn = () => {
    const { firstName } = this.props;
    const { headerURL, settingsLinkSufix } = this.getUrlMeta();

    return (
      <header className={s.header}>
        <Link to={headerURL}>
          <div className={s.logo} />
        </Link>
        {this.renderContacts()}
        <div className={s.user}>
          <i className={s.icon} />
          <span className={s.name}>{firstName}</span>
          <ul className={s.subItems}>
            <li>
              <Link to={`/${settingsLinkSufix}/my-details`}>Settings</Link>
            </li>
            <li>
              <div onClick={this.props.logOut} className={s.link}>
                Log out
              </div>
            </li>
          </ul>
        </div>
      </header>
    );
  };

  renderHeaderAdmin = () => (
    <header className={s.header}>
      <Link to="/admin">
        <div className={s.logo} />
      </Link>
      <div className={s.contacts} />
      <div className={s.user}>
        <i className={s.icon} />
        <span className={s.name}>Admin</span>
        <ul className={s.subItems}>
          <li>
            <div onClick={this.props.logOut} className={s.link}>
              Log out
            </div>
          </li>
        </ul>
      </div>
    </header>
  );

  render() {
    const { loading } = this.state;

    if (loading) {
      return null;
    }

    return (
      <div>
        {this.renderHeader()}
        <main>{this.props.children}</main>
        <footer className={s.footer}>
          &copy; {DB_CONST.SPProviderName} - 2018
        </footer>
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.object.isRequired,
  setUser: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired,
  role: PropTypes.number.isRequired,
  firstName: PropTypes.string,
};

const mapStateToProps = state => ({
  role: state.user.role,
  firstName: state.user.firstName,
});

const mapDispatchToProps = {
  setUser: userActions.setUser,
  logOut: userActions.logOut,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
